import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg, TOKEN_KEY } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function AdminAccount() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.new_password.length < 8) return setError("New password must be at least 8 characters.");
    if (form.new_password !== form.confirm) return setError("New passwords do not match.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      localStorage.setItem(TOKEN_KEY, data.token);
      toast.success("Password updated. Other sessions have been signed out.");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="panel space-y-4 p-5" data-testid="admin-account-form">
      <div className="flex items-center gap-2">
        <KeyRound size={16} className="text-blue-400" />
        <p className="eyebrow">Admin account · {user?.email}</p>
      </div>
      <label className="block"><span className="eyebrow mb-1 block">Current password</span><input className="field" type="password" value={form.current_password} onChange={set("current_password")} required autoComplete="current-password" data-testid="admin-current-password-input" /></label>
      <div className="grid gap-3 sm:grid-cols-2">
        <label className="block"><span className="eyebrow mb-1 block">New password</span><input className="field" type="password" value={form.new_password} onChange={set("new_password")} required minLength={8} autoComplete="new-password" data-testid="admin-new-password-input" /></label>
        <label className="block"><span className="eyebrow mb-1 block">Confirm new password</span><input className="field" type="password" value={form.confirm} onChange={set("confirm")} required autoComplete="new-password" data-testid="admin-confirm-password-input" /></label>
      </div>
      {error && <p className="rounded-xl border border-rose-500/40 bg-rose-500/10 px-4 py-3 text-sm text-rose-300" data-testid="admin-password-error">{error}</p>}
      <button className="btn-secondary w-full" disabled={busy} data-testid="admin-change-password-button">{busy ? "Updating…" : "Change password"}</button>
      <p className="text-xs text-slate-500">Once changed here, the password in <span className="font-mono">backend/.env</span> is no longer used for this account.</p>
    </form>
  );
}
